"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTimeSelectorFooter = void 0;
const react_1 = __importStar(require("react"));
const MainFooter_1 = require("./components/MainFooter/MainFooter");
const MainFooterWithOnlyTodayControl_1 = require("./components/MainFooterWithOnlyTodayControl/MainFooterWithOnlyTodayControl");
const MonthSelectorFooter_1 = require("./components/MonthSelectorFooter/MonthSelectorFooter");
const DateTimeSelectorFooter_styles_1 = require("./DateTimeSelectorFooter.styles");
exports.DateTimeSelectorFooter = react_1.default.memo(function DateTimeSelectorFooter({ monthSelectMode, isTodayDisabled, isApplyMonthSelectorDisabled, manualCloseMode, withTime, footerRenderer, texts, onApplyMonthSelector, onCancelMonthSelector, onMouseDown, onToday, onApply, onCancel }) {
    const dialogActions = (0, react_1.useMemo)(() => {
        if (monthSelectMode) {
            return (react_1.default.createElement(MonthSelectorFooter_1.MonthSelectorFooter, { isApplyMonthSelectorDisabled: isApplyMonthSelectorDisabled, onApplyMonthSelector: onApplyMonthSelector, onCancelMonthSelector: onCancelMonthSelector, onMouseDown: onMouseDown, texts: texts }));
        }
        if (manualCloseMode || withTime) {
            return (react_1.default.createElement(MainFooter_1.MainFooter, { isTodayDisabled: isTodayDisabled, onToday: onToday, onApply: onApply, onCancel: onCancel, onMouseDown: onMouseDown, texts: texts }));
        }
        return (react_1.default.createElement(MainFooterWithOnlyTodayControl_1.MainFooterWithOnlyTodayControl, { isTodayDisabled: isTodayDisabled, onToday: onToday, onMouseDown: onMouseDown, texts: texts }));
    }, [
        isApplyMonthSelectorDisabled,
        isTodayDisabled,
        manualCloseMode,
        monthSelectMode,
        onApply,
        onApplyMonthSelector,
        onCancel,
        onCancelMonthSelector,
        onMouseDown,
        onToday,
        texts,
        withTime
    ]);
    const customFooter = (0, react_1.useMemo)(() => footerRenderer === null || footerRenderer === void 0 ? void 0 : footerRenderer({
        isTodayDisabled,
        selectToday: onToday,
        apply: onApply,
        cancel: onCancel,
        texts
    }), [footerRenderer, isTodayDisabled, onApply, onCancel, onToday, texts]);
    return (react_1.default.createElement(DateTimeSelectorFooter_styles_1.StyledDateTimeSelectorFooter, { onMouseDown: onMouseDown, "data-selector-id": "date-time-selector-footer" }, footerRenderer ? customFooter : dialogActions));
});
//# sourceMappingURL=DateTimeSelectorFooter.js.map